var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnglishIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.31427,
    y: -0.00390625,
    width: 48.3602,
    height: 48.3602,
    rx: 24.1801,
    fill: "#68C9FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9184_1659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8143 13.1624C18.5547 13.1624 13.4797 17.6421 13.4797 23.1692C13.4797 25.9796 14.796 28.5113 16.9084 30.3292C16.4476 32.991 13.4699 34.0747 13.6734 34.8072C16.3361 35.9085 21.6093 33.352 22.409 32.9557C23.1821 33.1025 23.9916 33.1768 24.8143 33.1768C31.0738 33.1768 36.1488 28.6962 36.1488 23.1692C36.1488 17.6421 31.0729 13.1624 24.8143 13.1624Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9184_1659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(13.3143 12.9961)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishIcon);
export default __webpack_public_path__ + "static/media/EnglishIcon.0277a70b5f4893b037da2cc976a1ad29.svg";
export { ForwardRef as ReactComponent };